import React from 'react';

import type { IDraftJSActivity } from 'api/feed/types';

import { useRicosFormat } from 'common/utils/ricos';
import { RichContentViewer } from 'common/components/RichContent/Viewer';

import { CardContent } from 'wui/CardContent';

import { GROUPS_APP_DEFINITION_ID } from '../../../../constants';
import { getAriaId } from '../a11y';
import { IActivityContentProps } from './types';

export function RichContentActivity(props: IActivityContentProps) {
  const { item } = props;

  const feedItemId = item.feedItemId as string;
  const data = item?.activity?.data as IDraftJSActivity;
  const groupId = item.applicationContext?.contextId as string;

  const content = useRicosFormat(data.content);

  return (
    <CardContent id={getAriaId(feedItemId, 'content')}>
      <RichContentViewer
        usage="FeedItem"
        content={content}
        postId={feedItemId}
        containerId={GROUPS_APP_DEFINITION_ID}
        groupId={groupId}
        contentId={item.feedItemId}
      />
    </CardContent>
  );
}

RichContentActivity.displayName = 'RichContentActivity';
